import { useFormikContext } from 'formik';
import React from 'react';
import { TextField } from '@iclinic/design-system';

import { AppointmentGuideFormValues } from 'features/tissInvoicing/types/appointmentGuide';

type Identifiers = keyof AppointmentGuideFormValues;

interface TextFieldProps {
  label: string;
  identifier: Identifiers;
  minRows?: number;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
}

function TextFieldAppointmentGuide({
  label,
  identifier,
  minRows,
  required = false,
  disabled = false,
  maxLength,
}: TextFieldProps) {
  const { handleChange, values, errors, touched, handleBlur } =
    useFormikContext<AppointmentGuideFormValues>();

  const inputProps = {
    maxLength: maxLength || undefined,
  };

  return (
    <TextField
      label={label}
      id={identifier}
      name={identifier}
      type="text"
      value={values[identifier]}
      onChange={handleChange}
      error={!!errors[identifier]}
      helperText={touched[identifier] && errors[identifier]}
      onBlur={handleBlur}
      required={required}
      disabled={disabled}
      inputProps={inputProps}
      minRows={minRows}
      multiline={!!minRows}
      fullWidth
    />
  );
}

export default TextFieldAppointmentGuide;
